<template>
    <NavBar></NavBar>
    <IndexHeader></IndexHeader>
    <main>
        <IndexMovie></IndexMovie>
        <ShowTime v-on:getid="gotolayout"></ShowTime>
        <IndexPromo></IndexPromo>
        <IndexFooter></IndexFooter>

    </main>
    <div class="modal fade" id="largeModal" style="background-color: white;" tabindex="-1" role="dialog"
        aria-labelledby="basicModal" aria-hidden="true">
        <div class="modal-dialog modal-xl" style=" margin: 0px; border-radius: 0px;
    ">
            <div class="modal-content" style="border: 0px;
border-radius: 0px;">
                <div class="modal-header" style="border: none;">
                    <!--       <h4 class="modal-title" id="myModalLabel">Get Started</h4> -->
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body logpop" style="padding-top: 0px;">
                    <div class="row pt-0">
                        <div class="col-md-12">
                            <div class="membership">
                                <h6 style="font-size: 22px;">Get Started</h6>
                                <p style="font-size: 12px;">Sign in to your Palaxi Cinemas account to see your booking
                                    history and profile setting</p>
                                <form>
                                    <div class="or">
                                        <a href="#" class="facbg" style="width: 47%;margin-right: 3%;"><i
                                                class="lni lni-facebook-filled"></i>
                                            <small>Facebook</small>
                                        </a> <a href="#" class="gool"
                                            style="/*! margin: 0px !important; */width: 47%;margin-left: 3% !important;"><i
                                                class="lni lni-google"></i>
                                            <small>Google+</small>
                                        </a>
                                        <span>or</span>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="E-mail Address">
                                    </div>
                                    <div class="form-group">
                                        <input type="password" placeholder="Password"><i class="lni lni-eye"></i>
                                    </div>
                                    <div class="form-group">
                                        <a href="#" style="font-size: 12px;"><input type="checkbox" checked=""> Forgot
                                            Password?
                                        </a> <a href="#" style="margin-left: 10px; font-size: 12px;"><input type="checkbox"
                                                checked=""> Member Registration
                                        </a>
                                    </div>
                                    <div class="form-group">
                                        <input type="submit" value="Login">
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div> </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- large modal -->
   
    <div class="modal fade" id="largeModal22" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-body logpop">
                    <div class="row pad50">
                        <div class="col-md-7">
                            <div class="membership marb3">
                                <h6>Get Started</h6>
                                <p class="xsfon13">Sign in to your Palaxi Cinemas account to see your booking history
                                    and profile setting</p>
                                <form>
                                    <div class="or">
                                        <!-- <a href="#" class="facbg"><i class="lni lni-facebook-filled"></i>
                                            <small>with Facebook</small>
                                        </a>  -->
                                        <a href="#" class="gool"><i class="lni lni-google"></i>
                                            <small>with Google+</small>
                                        </a>
                                        <span>or</span>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="E-mail Address">
                                    </div>
                                    <div class="form-group">
                                        <input type="password" placeholder="Password"><i class="lni lni-eye"></i>
                                    </div>
                                    <div class="form-group">
                                        <a href="#" class="xsfon12"><input type="checkbox" checked=""> Forgot Password?
                                        </a> <a href="#" class="xsfon12" style="margin-left: 10px; "><input type="checkbox"
                                                checked=""> Member Registration
                                        </a>
                                    </div>
                                    <div class="form-group">
                                        <input type="submit" value="Login">
                                    </div>
                                </form>
                            </div>
                            <!-- end membership -->
                        </div>
                        <div class="col-md-5 ">

                            <div class="membership marb3">
                                <h6>Book as guest?</h6>
                            </div>
                            <p class="xsfon13">As a guest, you may miss out on offers and other account features.</p>
                            <div class="form-group">
                                <router-link class=" contbtn " :to="'/seatlayout/'+showid">Book as Guest</router-link>
                            </div>
                        </div>
                        <div> </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="smallmodal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body logpop">
          <div class="row pad50">
            Specified show tickets not available online.Please visit the box office!!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '../UI/NavBarmob.vue';
import IndexMovie from './IndexMoviemob.vue';
import ShowTime from './ShowTime.vue';
import IndexPromo from './IndexPromob.vue';
import IndexHeader from './IndexHeader.vue';
import IndexFooter from './IndexFooter.vue';

export default {
    components: {
        NavBar,
        IndexMovie,
        ShowTime,
        IndexPromo,
        IndexHeader,
        IndexFooter
    },
    data:()=>({
        isActive:false,
        showid:null,
    }),
    methods:{
        dropdown(){
            this.isActive=!this.isActive;
// $(this).find('.dropdown-menu').slideToggle(300);
document.find('.dropdown-menu').slideToggle(300);

        },
        dropdownfocusout(){
      document.querySelector('.dropdown').classList.remove('active');
      document.find('.dropdown-menu').slideUp(300);
        // $(this).find('.dropdown-menu').slideUp(300);
        },
        selected(){
        //     $(this).parents('.dropdown').find('span').text($(this).text());
        // $(this).parents('.dropdown').find('input').attr('value', $(this).attr('id'));
        },
        gotolayout(id){
this.showid=id;
        }
    }
}
</script>
